import React from 'react'
import styles from './styles.module.css'
import Text from '../../../Text'
import Youtube from '../../../Youtube'
import HighlightedText from '../../../Utils/HighlightedText'
import SimpleBlockContent from '../../../SimpleBlockContent'
import CtaV2 from '../../../CtaV2'
import Spacer from '../../../Spacer'

function Hero({ videoUrl, titleHl, text, ctaV2 }) {
  return (
    <div className={styles.heroWrapper}>
      {/* Single-<h1> rule (Audit A #1): the /creators-program hero title
          ("VRS® CREATORS PROGRAM") is the page's one visible <h1>. `.h1-contents`
          adds no box so the design is byte-identical. */}
      <h1 className="h1-contents"><div className={styles.titleWrapper}>
        <Text type="heading-1">VRS®</Text>
        <Text type="heading-1">CREATORS PROGRAM</Text>
      </div></h1>
      <div className={styles.videoAndText}>
        <div className={styles.videoWrapper}>
          <Youtube url={videoUrl} height="500"/>
        </div>
        <div className={styles.textWrapper}>
          <HighlightedText {...titleHl}/>
          <div className={styles.subtitleAndCta}>
            <SimpleBlockContent blocks={text} noSpace/>
            <Spacer size={16}/>
            <div className={styles.ctaWrapper}><CtaV2 {...ctaV2} fullWidth sx={{ height: '80px', titleTextType: 'large' }}/></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero
